module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl3-100.2fd18b5d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl3-100.png
// module id = 3333
// module chunks = 11